import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
var BITACORAIFCHANGEPRIORIZATION = 'prioritized_order';
var PrioritizeProductsComponent = /** @class */ (function () {
    function PrioritizeProductsComponent(navigationService, abreCuentasService, copyService, headerService, formBuilder, taggingService, bitacoraService) {
        this.navigationService = navigationService;
        this.abreCuentasService = abreCuentasService;
        this.copyService = copyService;
        this.headerService = headerService;
        this.formBuilder = formBuilder;
        this.taggingService = taggingService;
        this.bitacoraService = bitacoraService;
        this.select_products = [];
        this.statusValidation = false;
        this.back = '';
        this.headerService.show(true, true, true);
    }
    PrioritizeProductsComponent.prototype.ngOnInit = function () {
        var _this = this;
        // TODO: SETEO DE DATOS
        this.abreCuentasService.setProspectResponse({ client: false });
        this.select_products = this.abreCuentasService.getProductsSelects();
        this.formGroup = this.formBuilder.group(this.createForm());
        this.validateDulicate(this.formGroup.value);
        this.formGroup.valueChanges.subscribe(function (res) {
            _this.validateDulicate(res);
        });
    };
    /**
     * @returns crear validaciones para productos seleccionados
     */
    PrioritizeProductsComponent.prototype.createForm = function () {
        var e_1, _a;
        var values = {};
        var index = 0;
        try {
            for (var _b = tslib_1.__values(this.select_products), _c = _b.next(); !_c.done; _c = _b.next()) {
                var field = _c.value;
                values[index] = [field.flow];
                values[index].push(Validators.required);
                index++;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return values;
    };
    /**
     * @param object objeto resultante de formulario
     */
    PrioritizeProductsComponent.prototype.validateDulicate = function (object) {
        this.statusValidation = false;
        var array = [];
        var count = 0;
        for (var row in object) {
            count++;
            if (object[row] !== '') {
                if (array.indexOf(object[row]) !== (-1)) {
                    this.statusValidation = true;
                }
                array.push(object[row]);
            }
        }
    };
    /**
     * avanzar al siguiente paso
     */
    PrioritizeProductsComponent.prototype.next = function () {
        var sendExtras = {
            object: 'transactionProductDetails',
            value: this.addProductExtra(),
            pageValue: 'prioritize-products',
        };
        this.sendTagging('next', 'bottom', '3', sendExtras);
        this.validateIfNewPrioritize();
    };
    PrioritizeProductsComponent.prototype.sendTagging = function (value, position, event, extras) {
        var page = '31';
        this.taggingService.sendTaggValues(value, page, position, event, extras);
    };
    PrioritizeProductsComponent.prototype.addProductExtra = function () {
        var _this = this;
        var extras = '';
        this.select_products.forEach(function (product, index) {
            switch (product.product_code) {
                case 'TCR':
                    extras += 'TarjetaCredito';
                    break;
                case 'ORD':
                    extras += 'CreditoPersonal';
                    break;
                case 'CRP':
                    extras += 'CreditoRotativo';
                    break;
            }
            if (index < (_this.select_products.length - 1)) {
                extras += ',';
            }
        });
        return extras;
    };
    PrioritizeProductsComponent.prototype.validateIfNewPrioritize = function () {
        var _this = this;
        var callBitacora = false;
        var _loop_1 = function (index) {
            this_1.select_products.map(function (product) {
                if (product.flow === _this.formGroup.value[index]) {
                    product.prioritizeForClient = (+index + 1);
                    if (!_this.abreCuentasService.getPriorization()) {
                        if ("" + product.prioritizeForClient !== product.prioritize) {
                            callBitacora = true;
                            _this.abreCuentasService.setPriorization(true);
                        }
                    }
                }
                return product;
            });
        };
        var this_1 = this;
        for (var index in this.formGroup.value) {
            _loop_1(index);
        }
        if (callBitacora) {
            console.log(BITACORAIFCHANGEPRIORIZATION);
            this.bitacoraService.saveDataInBitacora(BITACORAIFCHANGEPRIORIZATION);
        }
        this.abreCuentasService.setProductsSelects(this.select_products);
        console.log('-----', this.abreCuentasService.getProductsSelects());
        this.navigationService.nextStep('200');
    };
    return PrioritizeProductsComponent;
}());
export { PrioritizeProductsComponent };
